import { Alert, Stack } from "@mui/material";
import { Facilities } from "Components/Shared/Merchant/Facilities/Facilities";
import type { MerchantFacilityDto } from "Infrastructure/Api/Api";
import type { CurrencyCode } from "Models/CurrencyCodes";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.Merchants.CompleteRegistration.Facilities;

type Props = {
  merchantPublicID: string;
  facilities: Array<MerchantFacilityDto>;
  isRequired: boolean;
  partyPublicID?: string | null;
  marketCurrencyCode?: CurrencyCode | string;
};

export const MerchantFacilities = ({
  merchantPublicID,
  facilities,
  isRequired,
  partyPublicID,
  marketCurrencyCode,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={4}>
      {isRequired && facilities.length === 0 && (
        <Alert severity="warning">{t(RESOURCES.RequiredInfo)}</Alert>
      )}
      <Facilities
        isOnboarding
        merchantPublicID={merchantPublicID}
        facilities={facilities}
        variant="minimal"
        partyPublicID={partyPublicID}
        marketCurrencyCode={marketCurrencyCode}
      />
    </Stack>
  );
};
